(() => {
  const unavailable = new Set([
    'CASE STUDY 2.5',
    'CASE STUDY 2',
    'CASE STUDY 1'
  ]);

  let queued = false;

  const normalise = (value) => (value || '')
    .replace(/\s*\(COMING SOON\)\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

  const applyStates = () => {
    queued = false;
    const scope = document.querySelectorAll(
      'header a, header button, nav a, nav button, .header a, .header button, .mobile-nav a, .mobile-nav button'
    );

    scope.forEach((item) => {
      const label = normalise(item.textContent);
      if (!unavailable.has(label)) return;

      const desired = label + ' (COMING SOON)';
      if ((item.textContent || '').trim() !== desired) item.textContent = desired;
      item.classList.add('aeliza-case-study-coming-soon');
      item.setAttribute('aria-disabled', 'true');
      item.setAttribute('tabindex', '-1');
      if (item.tagName === 'A') item.removeAttribute('href');
    });
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(applyStates);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
